export const waterSystemAcFilterOptions = [
    {value: 'BATTERY', label: 'Battery'},
    {value: 'AC_PLUGGED', label: 'AC plugged'},
    {value: 'AC_UNPLUGGED', label: 'AC unplugged'},
    {value: 'UNKNOWN', label: 'Unknown'},
];
